// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import MultipleFileInputController from "./multiple_file_input_controller"
application.register("multiple-file-input", MultipleFileInputController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RedirectionController from "./redirection_controller"
application.register("redirection", RedirectionController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import FormTemplateController from "./form_template_controller"
application.register("form-template", FormTemplateController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import FormActiveController from "./form_active_controller"
application.register("form-active", FormActiveController)

import RelevanceController from "./relevance_controller"
application.register("relevance", RelevanceController)

import IframeDisplayController from "./iframe_display_controller"
application.register("iframe-display", IframeDisplayController)
